import { Component } from '@angular/core';
import {NavController, NavParams, ViewController} from "ionic-angular";
import {Api} from "../../providers/api";
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'page-manage-bad-product-locations',
  templateUrl: 'manage-bad-product-locations.html',
})
export class ManageBadProductLocationsPage {

  items = [];
  private searchStatus: boolean = false;
  private productRefSearch: any;
  private productId: any;
  private allItems = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl:ViewController, public api:Api, private gVLogger: GVLogger) {
    this.items = this.navParams.get("items");
    this.allItems = this.items;
    console.log("itemmsss in ReferenceListPage" + JSON.stringify(this.items));

  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad ReferenceListPage');
  }

  selected(selected: string) :void {
    this.gVLogger.log("supplierSelected : " + selected);
    this.viewCtrl.dismiss(selected);
  }

  // onInputChange(event: any) {
  //   this.searchStatus = false;
  //   let substring = event.target.value;
  //
  //   if(this.productRefSearch === 1){
  //     //   this.api.get("products/getproductReferencesByProductId/" + substring+"?productId="+this.productId).map(res => res.json()).subscribe(data => {
  //     //     if (data.status === "200") {
  //     //       this.items = [];
  //     //       for (let item of data.data) {
  //     //         this.items.push(item.referenceNo);
  //     //         this.gVLogger.log("daaaattaaaaa : " + this.items);
  //     //       }
  //     //     } else {
  //     this.gVLogger.log("product ref search : " + this.searchStatus);
  //     this.items = [];
  //     this.searchStatus = true;
  //     //     }
  //     this.gVLogger.log("product ref search : " + this.searchStatus);
  //     //   })
  //   }
  //   else {
  //     if (substring.trim() == "") {
  //       substring = -1;
  //     }
  //     this.api.get("products/getReferencNo/" + substring)
  //       .map(res => res.json())
  //       .subscribe(data => {
  //         if (data.status === "200") {
  //           this.items = [];
  //           for (let item of data.data) {
  //             this.items.push(item.referenceNo);
  //             this.gVLogger.log("daaaattaaaaa : " + this.items);
  //           }
  //           this.searchStatus = false;
  //         } else {
  //           this.items = [];
  //           this.searchStatus = true;
  //           this.gVLogger.log("else case when no data found : " + this.searchStatus);
  //         }
  //       });
  //   }
  // }

  onInputChange(event: any) {
    // this.gVLogger.log("OOOOOOOO " + event.target.value)
    // let searchTerm = event.target.value;
    // if
    // this.items = this.items.filter(item => {
    //   return item.locationCode.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    // });

    this.items = this.allItems;
    const val = event.target.value

    if (val && val.trim() !== '') {
      this.items = this.items.filter(term => {
        return term.locationCode.toLowerCase().indexOf(val.trim().toLowerCase()) > -1;
      });
    }
  }



  // onInputChange(event) {
  //   const query = event.target.value.toLowerCase();
  //   requestAnimationFrame(() => {
  //     this.items.forEach(item => {
  //       const shouldShow = item.locationCode.toLowerCase().indexOf(query) > -1;
  //       item.style.display = shouldShow ? 'block' : 'none';
  //     });
  //   });
  // }



}



// WEBPACK FOOTER //
// ./src/pages/manage-bad-product-locations/manage-bad-product-locations.ts